import { useState } from "react"
import { Alert, Collapse } from "@mui/material"

export function ErrorAlert({ item }) {
    const [open, setOpen] = useState(true)
    return (
        <Collapse in={open}>
            <Alert severity="error" onClose={handleClose}>
                {item}
            </Alert>
        </Collapse>
    )

    function handleClose() {
        setOpen(false)
    }
}
